/** Version helpers for Snapshot Engine (v1, v2, v3…). */

export class SnapshotVersion {
  static label(version: number): string {
    return `v${Math.max(1, Math.floor(version))}`
  }

  static parse(label: string): number {
    const match = /^v?(\d+)$/i.exec(label.trim())
    if (!match) return 1
    return Math.max(1, Number(match[1]))
  }

  static next(versions: number[]): number {
    if (versions.length === 0) return 1
    return Math.max(...versions) + 1
  }

  static sortDesc<T extends { version: number }>(list: T[]): T[] {
    return [...list].sort((a, b) => b.version - a.version)
  }

  static isRelevantChange(previousJson: string, nextJson: string): boolean {
    return previousJson !== nextJson
  }
}
